import { ProjectLayoutApi } from 'api/ProjectLayoutApi';
import { backendApiClient } from 'container/backendApiClient';

export const projectLayoutApi: ProjectLayoutApi = new ProjectLayoutApi(backendApiClient);
